import { Star, Shield, Zap, Award, Truck, Sparkles } from "lucide-react";
import { motion } from "framer-motion";

const items = [
  { text: "500+ Cars Detailed", icon: Sparkles },
  { text: "5.0 ★ Rated on Google & Yelp", icon: Star },
  { text: "Satisfaction Guaranteed", icon: Shield },
  { text: "Premium Products Only", icon: Award },
  { text: "Fully Mobile Service", icon: Truck },
  { text: "Serving DC, MD, VA", icon: Zap },
  { text: "500+ Cars Detailed", icon: Sparkles },
  { text: "5.0 ★ Rated on Google & Yelp", icon: Star },
  { text: "Satisfaction Guaranteed", icon: Shield },
  { text: "Premium Products Only", icon: Award },
  { text: "Fully Mobile Service", icon: Truck },
  { text: "Serving DC, MD, VA", icon: Zap },
];

const SocialProofBar = () => (
  <div className="overflow-hidden relative py-6 border-y border-primary/10">
    {/* Gradient background */}
    <div className="absolute inset-0 bg-gradient-to-r from-primary/[0.02] via-primary/[0.05] to-primary/[0.02]" />
    <div className="absolute inset-0 bg-diagonal opacity-20" />
    
    {/* Fade edges */}
    <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-background to-transparent z-10" />
    <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-background to-transparent z-10" />
    
    <div className="flex animate-marquee whitespace-nowrap">
      {items.map((item, i) => (
        <motion.span
          key={i}
          className="flex items-center gap-3 mx-12 text-[11px] font-semibold tracking-[0.2em] uppercase text-primary/70"
          whileHover={{ scale: 1.05, color: "hsl(var(--primary))" }}
        >
          <span className="w-6 h-6 rounded-full bg-primary/5 flex items-center justify-center">
            <item.icon size={11} className="text-primary" />
          </span>
          {item.text}
        </motion.span>
      ))}
    </div>
  </div>
);

export default SocialProofBar;
